<!--ng-container *ngFor="let item of items; trackBy: trackByIndex">
         Paragraph block -->
<!-- <p *ngIf="item.isParagraph">
      <ng-container *ngFor="let part of item.content">
        <ng-container *ngIf="part.link; else textPart">
          <a [href]="part.link" target="_blank">{{ part.text }}</a>
        </ng-container>
        <ng-template #textPart>{{ part.text }}</ng-template>
      </ng-container>
    </p>
   -->
<!-- List block -->
<!-- <ng-container *ngIf="!item.isParagraph"> -->
<h5 *ngIf="heading">{{heading}}</h5>
<ng-container *ngIf="isOrdered(listType); else unorderedList">
  <ol [attr.type]="listType">
    <ng-container *ngTemplateOutlet="listBlock; context:{ $implicit: items }"></ng-container>
  </ol>
</ng-container>
<ng-template #unorderedList>
  <ul [attr.type]="listType" [ngClass]="{'no-marker':listType.toLowerCase()==='none'}">
    <ng-container *ngTemplateOutlet="listBlock; context:{ $implicit: items }"></ng-container>
  </ul>
</ng-template>
<!-- </ng-container> -->


<!-- Recursive list rendering -->
<ng-template #listBlock let-list>
  <li *ngFor="let li of list">
    <ng-container *ngFor="let part of li.content">
      <ng-container *ngIf="part.link; else textPart2">
        <a [href]="part.link" target="_blank">{{ part.text }}</a>
      </ng-container>
      <ng-template #textPart2>
        <span [innerHTML]="processText(part.text)"></span></ng-template>
    </ng-container>

    <!-- Nested list -->
    <ng-container *ngIf="li.nestedList">
      <app-nested-list-para-link [items]="li.nestedList.listItem" [listType]="li.nestedList.listType || listType">
      </app-nested-list-para-link>
    </ng-container>

    <!-- Paragraph after list item -->
    <ng-container *ngIf="li.paragraph">
      <p [innerHTML]="processText(li.paragraph)"></p>
    </ng-container>
  </li>
</ng-template>